import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Theme } from 'fq-ui';

Theme.applyDefaultTheme();
ReactDOM.render(<App />, document.getElementById('root'));
